import { jsx as _jsx } from "react/jsx-runtime";
import { Time } from '@wit-support/ui-domain';
import { ADS_TZ, tzLabelRu } from '../format.js';
/**
 * Время раздела — ВСЕГДА по Лос-Анджелесу и с подписью пояса (v3 §5): даты
 * шаблонов, пачек, шагов, сверок, медиатеки и списков. Один компонент на весь
 * раздел поверх кита (`Time` с `timeZone` + `zoneLabel`), а не пояс админа:
 * у оператора в Европе «10:14» без пояса читалось как его собственное время.
 */
export function AdsTime({ iso, preset = 'dateTimeNumeric', className, }) {
    return (_jsx(Time, { iso: iso, preset: preset, timeZone: ADS_TZ, zoneLabel: tzLabelRu(ADS_TZ), ...(className !== undefined ? { className } : {}) }));
}
//# sourceMappingURL=ads-time.js.map